// eslint-disable-next-line no-unused-vars
import React, {useState, useEffect, useRef} from "react";
import "./ConteudoViewer.scss";
// import api from "@api";
// import {stringToSlug} from "@helpers";
import Submenu from "@adoo-ui/Organism/Submenu";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Login from "@containers/Login";
import {Download as DownloadIcon} from "react-feather";
import {useLocation} from "react-router-dom";

import Layout from "@components/Layout";
import {useDiariosOficiais} from "@context/DiariosOficiais";
import {usePlanoAlertaModal} from "@context/PlanoAlertaModal";

import conteudoViewerText from "@api/requests/diarios/conteudoViewerText";
import usePageTitle from "@hooks/usePageTitle";

function ConteudoViewer(props) {
  usePageTitle(`${process.env.REACT_APP_SITE_NAME} - Baixar Diário Oficial`);
  const {handleDownloadDiario} = useDiariosOficiais();
  const {openAlert} = usePlanoAlertaModal();
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(false);
  const inputElement = useRef();

  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  //https://s3-sa-east-1.amazonaws.com/diariospdf/_2022/11/03/diario_oficial_uniao/530/0cc95633a7e35584eb0fc1c20823c616/diarioOficial.pdf
  const diario = `https://s3-sa-east-1.amazonaws.com/diariospdf/${searchParams.get(
    "diario"
  )}`;
  const diarioCdn = `https://cdn.adoo.com.br/diariospdf/${searchParams.get("diario")}`;
  const diarioParam = searchParams.get("diario");
  const pagina = searchParams.has("p") ? searchParams.get("p") : null;
  const reIndex = searchParams.has("reIndex") ? searchParams.get("reIndex") : null;
  const totalPaginas = searchParams.get("t");

  const onSuccessLogin = () => {
    setIsLoginFormVisible(false);
    inputElement.current.click();
  };

  useEffect(() => {
    async function fetchData() {
      const textoPdf = await conteudoViewerText(diario, pagina, reIndex);
      document.getElementById("pdf-texto").innerText = textoPdf;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout showContactForm={false}>
      <Login
        show={isLoginFormVisible}
        onSuccessLogin={onSuccessLogin}
        onHide={({action}) => {
          setIsLoginFormVisible(false);
        }}
      />
      <div className="app-wrapper-interno">
        <Submenu />
        <Container fluid className="mt-5">
          <Row>
            <Col className="text-center">
              <div
                className="do-card-full-download-icon"
                onClick={() =>
                  handleDownloadDiario(diarioCdn, openAlert, setIsLoginFormVisible)
                }
                ref={inputElement}
              >
                <DownloadIcon className="do-card-full-email-icon" color="#6034c7" />{" "}
                <span>Download do Diário</span>
              </div>
            </Col>
          </Row>
          <Row>
            <div id="pdf-texto">Por favor aguarde, carregando diário...</div>
          </Row>
          <Row>
            <nav id="pdf-paginacao">
              <ul className="pagination pagination-lg justify-content-center">
                {pagina > 0 && (
                  <li className="page-item">
                    <a
                      className="page-link"
                      href={`?diario=${diarioParam}&p=${
                        parseInt(pagina) - 1
                      }&t=${totalPaginas}`}
                    >
                      Anterior
                    </a>
                  </li>
                )}
                {pagina && (
                  <li className="page-item">
                    <div className="page-link">
                      <b>{parseInt(pagina) + 1} </b>
                      de {totalPaginas}
                    </div>
                  </li>
                )}
                {pagina < totalPaginas - 1 && (
                  <li className="page-item">
                    <a
                      className="page-link"
                      href={`?diario=${diarioParam}&p=${
                        parseInt(pagina) + 1
                      }&t=${totalPaginas}`}
                    >
                      Próxima
                    </a>
                  </li>
                )}
              </ul>
            </nav>
          </Row>
        </Container>
      </div>
    </Layout>
  );
}

export default ConteudoViewer;
